import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { hasAuthority, hasAnyAuthority } from '../utils/utils';

const SidebarComponent = ({ visible, onHide }) => {
    const navigate = useNavigate();
    const { theme } = useTheme();

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/entrar";
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            className="sidebar-menu"
            style={{ width: '280px' }}
        >
            <div className="sidebar-header">
                <img
                    src={theme === 'dark' ? require('../images/logo-dark.png') : require('../images/logo.png')}
                    alt="WGSol Logo"
                    className="sidebar-logo"
                    style={{width: "80%"}}
                />
                <p>Gestão de Obras</p>
            </div>
            <Accordion activeIndex={0} className="sidebar-accordion">
                <AccordionTab header="MENUS" className="sidebar-accordion-tab">
                    {hasAuthority('ADMINISTRADOR') && (
                        <a label="Usuários" icon="pi pi-fw pi-user" href="/usuarios">
                            <div>
                                <span className="pi pi-fw pi-user" style={{marginRight: "10px"}}/>Usuários
                            </div>
                        </a>
                    )}
                    {hasAnyAuthority(['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO']) && (
                        <a label="Equipes" icon="pi pi-fw pi-users" href="/equipes">
                            <div>
                                <span className="pi pi-fw pi-users" style={{marginRight: "10px"}}/>Equipes
                            </div>
                        </a>
                    )}

            
                    {hasAnyAuthority(['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO', 'FINANCEIRO', 'POS_VENDA', 'ORCAMENTISTA', 'VENDEDOR']) && (
                        <a label="Ordens de Serviço" icon="pi pi-fw pi-file" href="/ordens">
                            <div>
                                <span className="pi pi-fw pi-file" style={{marginRight: "10px"}}/>Ordens de Serviços
                            </div>
                        </a>
                    )}

                    {hasAnyAuthority(['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO', 'VENDEDOR']) && (
                        <a label="Procuração" icon="pi pi-fw pi-file-pdf" href="/procuracao" target="_blank">
                            <div>
                                <span className="pi pi-fw pi-file-pdf" style={{marginRight: "10px"}}/>Procuração
                            </div>
                        </a>
                    )}

                    {hasAnyAuthority(['TECNICO']) && (
                        <a label="Agenda" icon="pi pi-fw pi-users" href="/agenda">
                            <div>
                                <span className="pi pi-fw pi-users" style={{marginRight: "10px"}}/>Agenda
                            </div>
                        </a>
                    )}
                </AccordionTab>
                {hasAnyAuthority(['ADMINISTRADOR', 'AUXILIAR_ADMINISTRATIVO']) && (
                    <AccordionTab header="RELATÓRIOS" className="sidebar-accordion-tab">
                        
                            {hasAnyAuthority(['ADMINISTRADOR']) &&
                                <a label="Acompanhamento de Ordens" icon="pi pi-fw pi-chart-bar" href="/relatorios/acompanhamento">
                                    <div>
                                        <span className="pi pi-fw pi-chart-bar" style={{marginRight: "10px"}}/>Acompanhamento
                                    </div>
                                </a>
                            }

                            <a label="Relatório de Atendimento por Equipe" icon="pi pi-fw pi-chart-bar" href="/relatorios/atendimento-equipe">
                                <div>
                                    <span className="pi pi-fw pi-chart-bar" style={{marginRight: "10px"}}/>Atendimento por Equipe
                                </div>
                            </a>
                        
                    </AccordionTab>
                )}
            </Accordion>
            <div className="sidebar-logout" style={{ padding: '15px', marginTop: 'auto' }}>
                <Button
                    label="Sair"
                    icon="pi pi-sign-out"
                    className="p-button-danger w-full"
                    onClick={handleLogout}
                    style={{ width: '100%'}}
                />
            </div>
        </Sidebar>
    );
};

export default SidebarComponent;
